(function () {
  "use strict";

  document.documentElement.classList.remove("no-js");

  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Scroll reveal */
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll(".reveal:not(.reveal-in)");
    if (!els.length) return;
    if (reducedMotion || !("IntersectionObserver" in window)) {
      els.forEach(function (el) {
        el.classList.add("reveal-in");
      });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("reveal-in");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    els.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* Header scroll state + mobile menu */
  function initHeader() {
    var header = document.querySelector("[data-site-header]");
    if (!header) return;

    var onScroll = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 24);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    var toggle = header.querySelector("[data-menu-toggle]");
    var menu = document.querySelector("[data-mobile-menu]");
    if (!toggle || !menu) return;

    var setOpen = function (open) {
      if (open) {
        menu.style.paddingTop = header.getBoundingClientRect().bottom + "px";
      }
      menu.toggleAttribute("hidden", !open);
      header.classList.toggle("menu-open", open);
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      document.body.style.overflow = open ? "hidden" : "";
    };

    toggle.addEventListener("click", function () {
      setOpen(menu.hasAttribute("hidden"));
    });
    menu.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () {
        setOpen(false);
      });
    });
  }

  /* Cart drawer */
  var cart = {
    root: function () {
      return document.getElementById("CartDrawer");
    },

    open: function () {
      var root = cart.root();
      if (!root) return;
      root.classList.add("is-open");
      root.removeAttribute("aria-hidden");
      document.body.style.overflow = "hidden";
      var closeBtn = root.querySelector("[data-cart-close]");
      if (closeBtn) closeBtn.focus();
    },

    close: function () {
      var root = cart.root();
      if (!root) return;
      root.classList.remove("is-open");
      root.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    },

    renderSection: function (html) {
      var root = cart.root();
      if (!root || !html) return;
      var parsed = new DOMParser().parseFromString(html, "text/html");
      var fresh = parsed.getElementById("CartDrawer");
      if (!fresh) return;
      var wasOpen = root.classList.contains("is-open");
      root.innerHTML = fresh.innerHTML;
      root.classList.remove("is-busy");
      if (wasOpen) {
        root.classList.add("is-open");
        root.removeAttribute("aria-hidden");
      }
      cart.updateCount(fresh.getAttribute("data-item-count"));
    },

    updateCount: function (count) {
      if (count === null || count === undefined) return;
      document.querySelectorAll("[data-cart-count]").forEach(function (el) {
        el.textContent = count;
        el.toggleAttribute("hidden", parseInt(count, 10) === 0);
      });
    },

    change: function (line, quantity) {
      var root = cart.root();
      if (root) root.classList.add("is-busy");
      fetch(window.velarRoutes.cartChangeUrl + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: line, quantity: quantity, sections: "cart-drawer" }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (data.sections && data.sections["cart-drawer"]) {
            cart.renderSection(data.sections["cart-drawer"]);
          }
        })
        .catch(function () {
          if (root) root.classList.remove("is-busy");
        });
    },
  };

  function bindCartUi() {
    document.addEventListener("click", function (event) {
      var openTrigger = event.target.closest("[data-cart-open]");
      if (openTrigger) {
        event.preventDefault();
        cart.open();
        return;
      }
      if (event.target.closest("[data-cart-close]") || event.target.closest("[data-cart-overlay]")) {
        cart.close();
        return;
      }
      var lineBtn = event.target.closest("[data-line-change]");
      if (lineBtn) {
        cart.change(parseInt(lineBtn.getAttribute("data-line"), 10), parseInt(lineBtn.getAttribute("data-line-change"), 10));
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") cart.close();
    });
  }

  /* Add-to-cart forms */
  function initProductForms() {
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        var submitBtn = form.querySelector("[data-add-to-cart]");
        var errorEl = form.closest("[data-purchase-panel]")
          ? form.closest("[data-purchase-panel]").querySelector("[data-cart-error]")
          : null;
        if (submitBtn) {
          submitBtn.setAttribute("disabled", "disabled");
          submitBtn.classList.add("is-loading");
        }
        if (errorEl) errorEl.hidden = true;

        var body = new FormData(form);
        body.append("sections", "cart-drawer");

        fetch(window.velarRoutes.cartAddUrl + ".js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: body,
        })
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            if (data.status && data.status !== 200) {
              throw new Error(data.description || data.message || "error");
            }
            if (data.sections && data.sections["cart-drawer"]) {
              cart.renderSection(data.sections["cart-drawer"]);
            }
            cart.open();
          })
          .catch(function (err) {
            if (errorEl) {
              errorEl.textContent = err.message;
              errorEl.hidden = false;
            }
          })
          .finally(function () {
            if (submitBtn) {
              submitBtn.removeAttribute("disabled");
              submitBtn.classList.remove("is-loading");
            }
          });
      });
    });
  }

  /* Quantity steppers */
  function initQuantity() {
    document.addEventListener("click", function (event) {
      var btn = event.target.closest("[data-qty-change]");
      if (!btn) return;
      var wrap = btn.closest("[data-qty]");
      var input = wrap.querySelector("input[name='quantity']");
      var display = wrap.querySelector("[data-qty-value]");
      var next = Math.max(1, parseInt(input.value, 10) + parseInt(btn.getAttribute("data-qty-change"), 10));
      input.value = next;
      if (display) display.textContent = next;
    });
  }

  /* Variant picker */
  function initVariantPickers() {
    document.querySelectorAll("[data-purchase-panel]").forEach(function (panel) {
      var buttons = panel.querySelectorAll("[data-variant-select]");
      if (!buttons.length) return;
      var idInput = panel.querySelector("input[name='id']");
      var priceEl = panel.querySelector("[data-price]");
      var stockEl = panel.querySelector("[data-stock]");
      var addBtn = panel.querySelector("[data-add-to-cart]");

      buttons.forEach(function (btn) {
        btn.addEventListener("click", function () {
          buttons.forEach(function (b) {
            b.setAttribute("aria-pressed", b === btn ? "true" : "false");
          });
          var available = btn.getAttribute("data-available") === "true";
          if (idInput) idInput.value = btn.getAttribute("data-variant-id");
          if (priceEl) priceEl.textContent = btn.getAttribute("data-price");
          if (stockEl) {
            stockEl.textContent = available ? stockEl.getAttribute("data-label-in-stock") : stockEl.getAttribute("data-label-sold-out");
            stockEl.classList.toggle("is-sold-out", !available);
          }
          if (addBtn) {
            addBtn.toggleAttribute("disabled", !available);
            addBtn.textContent = available ? addBtn.getAttribute("data-label-add") : addBtn.getAttribute("data-label-sold-out");
          }
        });
      });
    });
  }

  /* Product gallery */
  function initGallery() {
    document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
      var mains = gallery.querySelectorAll("[data-gallery-main]");
      var thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var index = thumb.getAttribute("data-index");
          mains.forEach(function (main) {
            main.toggleAttribute("hidden", main.getAttribute("data-index") !== index);
          });
          thumbs.forEach(function (t) {
            t.setAttribute("aria-current", t === thumb ? "true" : "false");
          });
        });
      });
    });
  }

  /* Contact reason preselect from ?reason= */
  function initContactReason() {
    var select = document.querySelector("[data-reason-select]");
    if (!select) return;
    var reason = new URLSearchParams(window.location.search).get("reason");
    if (!reason) return;
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value.toLowerCase() === reason.toLowerCase()) {
        select.selectedIndex = i;
        break;
      }
    }
  }

  /* Newsletter consent gating */
  function initNewsletter() {
    document.querySelectorAll("[data-newsletter]").forEach(function (form) {
      var consent = form.querySelector("[data-newsletter-consent]");
      var submit = form.querySelector("button[type='submit']");
      if (!consent || !submit) return;
      var sync = function () {
        submit.toggleAttribute("disabled", !consent.checked);
      };
      consent.addEventListener("change", sync);
      sync();
    });
  }

  function init() {
    initReveal();
    initHeader();
    bindCartUi();
    initProductForms();
    initQuantity();
    initVariantPickers();
    initGallery();
    initContactReason();
    initNewsletter();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initReveal(event.target);
    initProductForms();
    initVariantPickers();
    initGallery();
    initNewsletter();
  });
})();
